import { FC, useEffect } from 'react';
import StudioSidebar from 'components/StudioSidebar';
import { Header } from 'components/Header';
import useActiveWorkspace from 'hooks/useActiveWorkspace';
import { useParams } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';

const StudioLayout: FC = ({ children }) => {
  const { workspaceArray, sessionWorkspace } = useActiveWorkspace();
  const { workspaceId } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    if (workspaceArray.length) {
      const exists = workspaceArray.some((ws: any) => ws.workspace_id === workspaceId);
      if (!exists) {
        navigate(`/workspace/${sessionWorkspace}/videos/all`);
      }
    }
  }, [workspaceArray, navigate, workspaceId]);

  return (
    <div className="h-screen w-screen flex flex-col">
      <Header />
      <div className="flex h-full">
        <StudioSidebar />
        <div className="w-full flex-1 min-w-0 font-lato">
          <div className="flex h-full">
            <div className="w-full h-full">{children}</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export { StudioLayout };
